import { UserSummary } from './user-summary.model';
import { TimeOff } from '../timeoff/timeoff.model';
import { LoanProgram } from '../loanprograms/loanprogram.model';
import { LoanProgramLoRelationship } from '../loanprograms/loanprogram.model';
import { Team } from '../teams/team.model';
import { CollateralSkillSet } from '../collateralskillsets/collateralskillset.model';

export class User extends UserSummary {
    public firstName: string;
    public lastName: string;
    public relationships: UserSummary[];
    public relationshipIds: string[];
    public loanPrograms: LoanProgram[];
    public encompassUserName: string;
    public teamEmail: string;
    public loanProgramIds: string[];
    public loanProgramLoRelationships: LoanProgramLoRelationship[];
    public teams: Team[];
    public teamIds: string[];
    public timeOffDateRanges: TimeOff[];
    public hasSpecialties: boolean;
    public hasTimeOffs: boolean;
    public loggedInUserEmail: string;
    public warningMessages: string[];
    public collateralSkillsets: CollateralSkillSet[] = [];
    public collateralSkillsetIds: string[];
    public whiteGlove: string;
    public region15: Region15;
}

export class Region {
    public id: string;
    public name: string;
    public group: string;
    public tooltip: string;
}

export class Region15 {
    public id: string;
    public userId: string;
    public option: string;
}




// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/users/user.model.ts